import PageMeta from "~/components/common/meta";
import { Profile } from "~/components/staff/profile";

export const ProfileScreen = () => {
  return (
    <>
      <PageMeta title="Profile | Art Handler" />
      <Profile />
    </>
  );
};
